import { Div, P } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';
import React, { useEffect, ChangeEvent, useContext } from 'react';
import { FormPropsWithValue } from '../HOCs';
import { MainCoverageBlock, MainCoverageBlockProps } from './Block';
import { ComparatorContext, useField } from '@kizi/comparator-core';

export interface MainCoverageSectionProps extends FormPropsWithValue {
  items: MainCoverageBlockProps[];
  itemsInARow?: number;
}

export const MainCoverageSection: React.VFC<MainCoverageSectionProps> = ({
  items,
  itemsInARow = 3,
  ...input
}) => {
  const coverageAdviceField = useField('getUserInput.coverageAdvice');
  const advice = String((coverageAdviceField?.value as any).advice);
  const { name } = useContext(ComparatorContext);
  useEffect(() => {
    if (!input.value && input.onChange && name === 'car') {
      const matchingItem = items.find(
        (item) => item.radio && String(item.radio.value) === advice,
      );

      if (matchingItem?.radio?.value) {
        const syntheticEvent = {
          target: {
            value: matchingItem.radio.value,
            name: input.name,
            type: 'radio',
            checked: true,
          },
          preventDefault: () => {},
          stopPropagation: () => {},
        } as ChangeEvent<HTMLInputElement>;

        input.onChange(syntheticEvent);
      }
    }
  }, []);

  return (
    <Div
      display="flex"
      flexDirection="column"
      gridGap={[3, null, 4]}
      data-testid="MainCoverageSection"
    >
      {input._error && (
        <Div
          textAlign={['left', null, 'center']}
          display="flex"
          gridGap={2}
          alignItems="center"
          justifyContent={['flex-start', null, 'center']}
          data-testid="MainCoverageSection.error"
        >
          <IconV2
            name="alert"
            width={20}
            height={20}
            fill="supplementary.5"
            data-testid="MainCoverageSection.error.icon"
          />
          <P
            variant="footnoteError"
            data-testid="MainCoverageSection.error.text"
          >
            {input._error}
          </P>
        </Div>
      )}
      <Div
        display="grid"
        gridGap={[4, null, 6]}
        gridTemplateColumns={[null, null, `repeat(${itemsInARow}, 1fr)`]}
        data-testid="MainCoverageSection.list"
      >
        {items.map((item, idx) => (
          <MainCoverageBlock
            {...item}
            radio={
              item.radio && input.onChange // Add type guard here too
                ? {
                    ...item.radio,
                    name: input.name,
                    checked: String(item.radio.value) === String(input.value),
                    onChange: input.onChange,
                  }
                : undefined
            }
            key={idx}
            data-testid="MainCoverageSection.block"
          />
        ))}
      </Div>
    </Div>
  );
};
